import{isObject as i,isBoolean as n}from"@guildeducationinc/type-guards";var o=function(o){return i(o)&&(!("loading"in o)||n(o.loading))};export{o as isLoadable};
//# sourceMappingURL=Loadable.js.map
